import { Injectable } from '@angular/core';
import {
  AppSwitcherConfigService,
  LuigiCoreService,
  LuigiNode,
  NodeUtilsService,
} from '@openmfp/portal-ui-lib';

interface NodeConfig {
  title: string;
  icon: string;
  link: string;
  testId?: string;
  selectionConditions?: {
    route: string;
    contextCriteria: {
      key: string;
      value: string;
    }[];
  };
}

@Injectable({ providedIn: 'root' })
export class DxpAppSwitcherConfigService implements AppSwitcherConfigService {
  constructor(
    private luigiCoreService: LuigiCoreService,
    private nodeUtilsService: NodeUtilsService,
  ) {}

  getAppSwitcher(luigiNodes: LuigiNode[]) {
    return {
      keepMainTitle: true,
      showSubTitle: false,
      itemRenderer: (item: any, slot: HTMLElement, appSwitcherApiObj: any) => {
        const a = document.createElement('a');
        a.setAttribute('class', 'fd-menu__link');
        a.setAttribute('data-testid', item.testId);
        a.addEventListener('click', (e) => {
          this.luigiCoreService.navigation().navigate(item.link);
          appSwitcherApiObj.closeDropDown();
          e.stopPropagation();
        });

        const span = document.createElement('span');
        span.setAttribute('class', 'fd-menu__addon-before');
        const i = document.createElement('i');
        i.setAttribute('class', 'sap-icon--' + item.icon);
        span.appendChild(i);

        const spanText: HTMLElement = document.createElement('span');
        spanText.setAttribute('class', 'fd-menu__title');
        spanText.innerText = item.title;
        a.appendChild(span);
        a.appendChild(spanText);
        slot.innerHTML = '';
        slot.appendChild(a);
      },
      items: (luigiNodes || [])
        .filter((node: LuigiNode) => {
          return (
            node.globalNav &&
            !node.category &&
            !node.hideFromNav &&
            this.nodeUtilsService.isVisible(node)
          );
        })
        .map((node) => {
          const nodeConfig: NodeConfig = {
            title: node.label ?? '',
            icon: node.icon ?? '',
            link: '/' + node.pathSegment,
            testId: node.testId || node.label,
          };
          return nodeConfig;
        }),
    };
  }
}
